module.exports = __webpack_public_path__ + "static/media/ifb.aa72de7e.jpg";